import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=56b14cf2&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=56b14cf2&lang=scss&scoped=true&"
import style1 from "./ClientList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b14cf2",
  null
  
)

export default component.exports